// extracted by mini-css-extract-plugin
export default {"card":"FilterTable_card__m35M0","selectContianer":"FilterTable_selectContianer__YIQ59"};